import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DownloadExcelComponent } from 'src/app/module/shared/components/download-excel/download-excel.component';
import { ViewEditCommonComponent } from 'src/app/module/shared/components/view-edit-common/view-edit-common.component';
import { AccessControlService } from 'src/app/shared/services/AccessControl.service';
import { TabService } from 'src/app/shared/tab.service';
import { AddBudgetComponent } from '../add-budget/add-budget.component';
import { CommonBulkPrintComponent } from 'src/app/module/shared/components/common-bulk-print/common-bulk-print.component';
import { CommonCsvComponent } from 'src/app/module/shared/components/common-csv/common-csv.component';
import { BudgetsService } from '../../services/budgets.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-budget',
  templateUrl: './budget.component.html',
  styleUrls: ['./budget.component.css']
})
export class BudgetComponent {
  theme = 'dark'
  pageSize = 100; // Number of items per page
  pageIndex = 0;
  currentPage: number = 0;
  pageNumber = 0;
  sortingCol : string = 'id';
  direction : string = 'DESC' 
  tableName= 'budgetTable'
  warehouseFilter: any = [];
  warehouseData: any = [];
  getWarehouseList: any;
  customerModel: any;
  selectedWarehouse: any;
  storedWarehouse: any;
  clientId: any;
  clientDetails: any;
  ref: DynamicDialogRef | undefined;
  selectedData:  any[]=[];
  editContation: boolean = false;
  // filters= [];
  filters: { key: string; value: any }[] = [];

  columns = [
    // {showColumn: true, sortingColumn: 'Id',  key: 'id', header: 'ID', sortable: true, type: 'text', viewDialog: true, viewHistory: true, componentName: 'Budget' },
    {showColumn: true, sortingColumn: 'financialYearId',  key: 'financialYear', header: 'Financial Year', sortable: false, type: 'text', viewDialog: true, viewHistory: true, componentName: 'Budget' },
    {showColumn: true, sortingColumn: 'budgetDate',  key: 'budgetDate', header: ' Month ', sortable: true, type: 'month', viewDialog: false },
    {showColumn: true, sortingColumn: 'accountId',  key: 'accountName', header: 'Customer', sortable: false, type: 'text', viewDialog: false },
    {showColumn: true, sortingColumn: 'warehouseId',  key: 'warehouseName', header: 'Warehouse Name', sortable: false, type: 'text' },
    {showColumn: true, sortingColumn: '',  key: 'expense', header: 'Expenses', sortable: false, type: 'text', viewDialog: false },
    // {showColumn: true, sortingColumn: 'zoneId',  key: 'zone', header: 'Zone', sortable: true, type: 'text' },
    // {showColumn: true, sortingColumn: 'customerOwned',  key: 'customerOwned', header: 'Customer Owned', sortable: true, type: 'text' },
    {showColumn: true, sortingColumn: 'approvedBudget',  key: 'approvedBudget', header: 'Budget Amount', sortable: true, type: 'text', viewDialog: false },
    {showColumn: true, sortingColumn: 'budgetTypeId',  key: 'budgetType', header: 'Budget Type', sortable: false, type: 'text' },
    {showColumn: true, sortingColumn: 'warehouseTypeId',  key: 'warehouseType', header: 'Warehouse Type', sortable: false, type: 'text' },
    // {showColumn: true, sortingColumn: 'expenseTypeId',  key: 'expenseType', header: 'Expenses Type', sortable: true, type: 'text', viewDialog: false },
    {showColumn: true, sortingColumn: 'budgetProof',  key: 'budgetProof', header: 'Budget Proof', sortable: false, type: 'file' },
    {showColumn: true, sortingColumn: 'designation',  key: 'designation', header: 'Designation', sortable: false, type: 'text' },
    {showColumn: true, sortingColumn: 'band',  key: 'band', header: 'Band', sortable: false, type: 'text' },
    {showColumn: true, sortingColumn: 'remarks',  key: 'remarks', header: 'Budget Updated-Remark', sortable: true, type: 'text' },
    {showColumn: true, sortingColumn: 'referenceId',  key: 'reference', header: 'Reference', sortable: false, type: 'text' },
    {showColumn: true, sortingColumn: 'createdAt',  key: 'createdAt', header: 'Created At', sortable: true, type: 'date' },
    {showColumn: true, sortingColumn: '',  key: 'createdByName', header: 'Created By', sortable: false, type: 'text' },
    {showColumn: true, sortingColumn: 'updatedAt',  key: 'updatedAt', header: 'Updated At', sortable: true, type: 'date' },
    {showColumn: true, sortingColumn: '',  key: 'updatedByName', header: 'Updated By', sortable: false, type: 'text' },
    // {showColumn: true, sortingColumn: 'totalExpenseAmount',  key: 'totalExpenseAmount', header: 'Total Expense Amount', sortable: true, type: 'text' },
  ];

  columnsToExport: string[]  = ['financialYearId', 'budgetDate', 'budgetType','reference','accountName','warehouseName','approvedBudget', 'expense', 'createdAt', 'createdByName', 'updatedAt', 'updatedByName', 'budgetProof', 'remarks'];

  dropdownOptions: { [key: number]: string[] } = {
    0: ['2023-2024', '2022-2023'],
    1: ['January', 'February', 'March'],
  };

  warehouseList = []; // Define warehouse list here
  accounts = []; // Define account list here
  totalCount:any;
  @ViewChild(DownloadExcelComponent) downloadExcel!: DownloadExcelComponent;
  @ViewChild(CommonBulkPrintComponent) printData!: CommonBulkPrintComponent;
  @ViewChild(CommonCsvComponent) downloadCsv!: CommonCsvComponent;

  selectedRows: any[] = [];
  tableLists: any;
  user_details: any;
  accountMappingList: any;
  constructor(private BudgetsService : BudgetsService, 
    private primengConfig: PrimeNGConfig, private fb: FormBuilder,  private tabService: TabService,
    public dialogService: DialogService, private messageService: MessageService, private router: Router, public accessControlService: AccessControlService) {
    this.getWarehouseList = JSON.parse(localStorage.getItem('wareHouseList')!)
    this.accounts = JSON.parse(localStorage.getItem('accountList')!)
    this.user_details = JSON.parse(localStorage.getItem('user_details')!)
    this.accountMappingList = JSON.parse(localStorage.getItem('accountMappingList')!);
    this.primengConfig.ripple = true;
  }

  searchForm = this.fb.group({
    WAREHOUSE_ID_IN: new FormControl(''),
    ACCOUNT_ID_IN: new FormControl(''),
    // FC_NAME: new FormControl(''),
    STATUS: new FormControl(null)
  });

  ngOnInit(): void {
  this.getList()
  }

  getWarehouseDetails(pageIndex: number, pageSize: number, filter: any) {
    // const warehouseFilter = this.setFilter();
    this.warehouseData = []
    this.totalCount = 0
    // this.warehouseService.getWarehouseList(pageIndex, pageSize, filter).subscribe((res: any) => {
    //   this.warehouseData = res?.responseObject?.content;
    //   this.totalCount = res?.responseObject?.totalElements;
    // })
  }
   
  getList() {
    if(this.filters.length < 1){
      const extractedIds = this.accountMappingList.map((item: any) => item.id);
      const valueString = extractedIds.join(',');
      this.filters = valueString
  ? [
      {
        key: 'MAPPING_IN',
        value: valueString,
      }
    ]
  : [];
      // this.filters = [{ key: "MAPPING_IN", value: valueString }];
    }
    this.tableLists = []
    this.BudgetsService
      .getBudgets(this.filters, this.pageNumber, this.pageSize,this.sortingCol,this.direction)
      .subscribe((data: any) => {
        if(data){
          this.tableLists = data?.responseObject?.content;
          this.totalCount = data?.responseObject?.totalElements;
          this.tableLists?.forEach((el:any)=>{
            // el.budgetProof = el?.budgetProof.split(',')
          })
          console.log(this.tableLists)
          this.selectedData = []

        }
      },err => {
        // console.log(err);
        this.totalCount = 0
        this.tableLists = []
      });
  }

  getListExportApi = (params: any): Observable<any> => {
      const {
        filters = {}, pageNumber = 0, pageSize = 250, sortingCol = 'id',
        direction = 'DESC'
      } = params;
    
      return  this.BudgetsService.getBudgets(
        filters, pageNumber, pageSize, sortingCol, direction
      );
    };

  onFilterChange(event: any) {
    if(event){
      this.filters = event
      this.getList()
    }
  }

  onResetFilters() {
    this.filters = []
    this.getList()
  }

  paginate(event: any) {
    this.pageNumber = event.pageIndex
    this.pageSize = event.pageSize
    this.currentPage = event.pageIndex
    this.getList()
  }
  
  onSortChange(event: { columnKey: string, sortOrder: 'ASC' | 'DESC' }): void {
    this.sortingCol = event.columnKey
    this.direction = event.sortOrder
    this.getList()
  }

  onSelectedRowsChange(selectedRows: any[]) {
    const storedData = JSON.parse(localStorage.getItem('columnToExport') || '{}');

    this.columnsToExport = storedData['budget'] ?? this.columnsToExport;
  
    this.selectedRows = selectedRows;
    this.selectedData = selectedRows;
  
    if (this.downloadExcel) {
      this.downloadExcel.data = [...selectedRows];
    } else {
      console.error('DownloadExcelComponent is not initialized.');
    }
  }

  addBudget(type:any) {
    this.ref = this.dialogService.open(AddBudgetComponent, {
      header: `${type} Budget`,
      data: type == 'Add' ? {} : {
        editData : this.selectedData,
        edit: this.editContation
      },
      width: '70vw',
      contentStyle: { overflow: 'auto', position: "top" },
      draggable: true,
      styleClass: 'no-close-icon-dialog',
    });
    this.ref.onClose.subscribe((data: any) => {
      console.log("resss", data)
      if (data) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: data?.responseMessage,
        });
        this.getList()
      }
    });
  }



  receiveDataEvent(data: any[]) {
    console.log(data) 
    this.selectedData = data
  }
  editEvent(){
    this.editContation = true
    console.log( this.editContation)
    this.addBudget('Edit')
  }
  deleteEvent(){
    // const ids = Array.from(new Set(this.selectedData.map((item: any) => item.id))).join(',');
    // this.emsServices.deleteExpense(ids).subscribe((data: any) => {
    //   if(data){
    //     this.selectedData = [];
    //     this.getList();
    //     this.messageService.add({
    //       severity: 'success',
    //       summary: 'Success',
    //       detail: 'Expense Deleted successfully',
    //     });
    //   }
    //  },err => {
    //   this.tableLists = []
    //  });
  }

  duplicateEvent(){
    console.log(this.selectedData)
    const payload = {
      expenseCategoryId: this.selectedData[0].expenseCategoryId,
      expenseModeId: this.selectedData[0].expenseModeId,
      expenseName: this.selectedData[0].expenseName,
      status: this.selectedData[0].status,
     };
    //  this.emsServices.expenseAddOrUpdate(payload).subscribe((data: any) => {
    //   if(data){
    //    this.messageService.add({
    //      severity: 'success',
    //      summary: 'Success',
    //      detail: 'Expense added successfully',
    //    });
    //    this.getList();
    //    this.selectedData = [];
    //   }
    //  });
  }


  upload(url:any,params:any){
    this.tabService.addTab({
      label: 'Upload', path: url,
      fullPath: '',
      filterData: [],
      // pageNumber: 0,
      // pageSize: 10
    });
  this.router.navigate([url],{ queryParams: params })
  }

}
